import { queryClient } from '@service-initiation/shared-utils-query-client';

import {
  type CreateAppointmentIntentProps,
  generateCreateAppointmentIntentCacheKey,
} from '../createAppointmentIntent';

export const invalidateCreateAppointmentIntentQuery = (
  request: CreateAppointmentIntentProps
) =>
  queryClient.invalidateQueries({
    queryKey: generateCreateAppointmentIntentCacheKey(request),
  });
